import { Controller } from "@hotwired/stimulus"
import { animate } from 'animejs'

// Connects to data-controller="delay-hide"
export default class extends Controller {

	static targets = ['reanimate']

	static values = {
		delayMilliseconds:   { type: Number, default: 5000 },
		animateMilliseconds: { type: Number, default: 300 },
		animation:           { type: String, default: 'fadeOut' }
	}

	connect() {
		this.animate()
	}

	reanimateTargetConnected(target) {
		target.remove()
		this.animate()
	}

	animate() {
		if (this.animationValue == 'fadeOut') this.fadeOut()
	}

	fadeOut() {
		animate(this.element, {
			opacity:  0.0,
			duration: this.animateMillisecondsValue,
			delay:    this.delayMillisecondsValue,
			//onComplete: () => {this.element.classList.add('d-none')},
		})
	}
}
